import React from 'react';
import LanguageSelection from './language-selection';
import Link from '../../link';
import compose from 'lodash.compose';
import attachI18n from '../../hoc/attach-i18n';
import withErrors from '../../hoc/with-errors';
import { translate } from 'react-i18next';

// TODO: translations?
const Footer = ({ t }) => (
  <footer id="footer" className="style1">
    <div className="inner">
      <ul className="copyright" style={{ marginBottom: 0 }}>
        <li>&copy; E. SASSONE SRL</li>
        <li>Via Castellero, 12 14013 Monale (AT)</li>
        <li>
          <Link href="/privacy">
            <a>
              {t('privacy:title')}
            </a>
          </Link>
        </li>
        <li>Tel. <a href="tel:+390141669691">+39 0141 669 691</a></li>
        <li><a href="mailto:info@esassone.com">info@esassone.com</a></li>
        <li><a href="https://www.linkedin.com/company/e-sassone-srl/"><i className="fa fa-linkedin" /></a></li>
      </ul>
      <ul className="copyright">
        <li>Partita Iva 01022950057</li>
        <li>C.F. 00417710019</li>
        <li>Reg.Imp. Asti 73312</li>
        <li>Cap. Soc. i.v. € 1.332.046,56</li>
        <li>Powered by: <a href="https://www.industrial-cloud.com">Industrial Cloud</a></li>
        <li><LanguageSelection/></li>
      </ul>
    </div>
  </footer>
);

export default compose(
  translate(),
  attachI18n('privacy'),
)(Footer);
